// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// TanOak Platform Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBntsV9AXBhzd1WB1H9fYBUEvB-dQkLDl0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "tanoak-platform.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "tanoak-platform",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "tanoak-platform.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "269634243466",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:269634243466:web:2b9bf7386c010d4aff9673",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-4HXMJ5JM4S"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firebase services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;